import { Route } from "react-router-dom";
import ParentDashboard from "pages/parent/ParentDashboard";
import ProtectedRoute from "components/ProtectedRoute";

export const ParentRoutes = () => [
    // <Route key="parent login page" path="/parent/login" element={<ParentLogin />} />,
    <Route key="wisdom Parent Dashboard" path="/parent" element={
        <ProtectedRoute>
            <ParentDashboard />
        </ProtectedRoute>
    } />,
];